module.exports = __webpack_public_path__ + "img/img-1.ce85f131.jpg";